<template>
  <p class="clearfix mb-0">
    <span class="float-md-left d-block d-md-inline-block mt-25">
      © {{ new Date().getFullYear() }}
      <b-link
        class="ml-25"
        href="https://jakaset.jakarta.go.id"
        target="_blank"
      >BPAD Provinsi DKI Jakarta</b-link>
      <span class="d-none d-sm-inline-block pl-1">Pusdatin Aset</span>
    </span>
  </p>
</template>

<script>
import { BLink } from 'bootstrap-vue'

export default {
  components: {
    BLink,
  },
}
</script>
